import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  initialEditorInstance,
  initialRichTextEditorState,
} from './initialState'
import { LinkBubbleData } from './types'

function ensureEditor(state: typeof initialRichTextEditorState, id: string) {
  if (!state.editors[id]) {
    state.editors[id] = { ...initialEditorInstance }
  }
  return state.editors[id]
}

const slice = createSlice({
  name: 'richTextEditor',
  initialState: initialRichTextEditorState,
  reducers: {
    showLinkBubble: (
      state,
      action: PayloadAction<{ editorId: string; bubble: LinkBubbleData }>
    ) => {
      const editor = ensureEditor(state, action.payload.editorId)
      editor.linkBubble = action.payload.bubble
    },
    closeLinkBubble: (state, action: PayloadAction<string>) => {
      const editor = state.editors[action.payload]
      if (editor) {
        editor.linkBubble = null
        editor.linkInputValue = ''
      }
    },
    editLink: (state, action: PayloadAction<string>) => {
      const editor = state.editors[action.payload]
      if (editor?.linkBubble) {
        editor.linkBubble.mode = 'edit'
      }
    },
    setLinkInputValue: (
      state,
      action: PayloadAction<{ editorId: string; value: string }>
    ) => {
      const editor = ensureEditor(state, action.payload.editorId)
      editor.linkInputValue = action.payload.value
    },
    removeEditor: (state, action: PayloadAction<string>) => {
      delete state.editors[action.payload]
    },
  },
})

export const reducer = slice.reducer
export const {
  showLinkBubble,
  closeLinkBubble,
  editLink,
  setLinkInputValue,
  removeEditor,
} = slice.actions
